import { render } from "./detail-billing.vue?vue&type=template&id=52e9cc2f&scoped=true"
import script from "./detail-billing.vue?vue&type=script&lang=js"
export * from "./detail-billing.vue?vue&type=script&lang=js"

import "./detail-billing.vue?vue&type=style&index=0&id=52e9cc2f&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e9cc2f"]])

export default __exports__